export default __webpack_public_path__ + "static/media/rl-1-rMAX.9461e623.jpg";